import './style.scss'

import imagesAdd from 'assets/image/icons/buttons/add.svg'
import TableTeams from 'components/molecules/TableTeams'
import { teamHooks, TeamUI } from 'features/team'
import { TeamSideId } from 'features/team/const'
import { leftSideHooks } from 'shared/hooks'
import { Button } from 'shared/ui'

import { useLegacyPersonas } from '../useLegacyPersonas'

export function MembersPage() {
	const showMembers = teamHooks.useIsEnable()

	const [personas, { refetch }] = useLegacyPersonas()
	leftSideHooks.useActive(TeamSideId.Members)

	return (
		<TeamUI.Wrapper
			header={
				<div className='flex-container-team-members'>
					{showMembers && (
						<>
							<h2 className='teams-main-title-members'>Members</h2>

							<Button
								className='button-member'
								onClick={TeamUI.Wrapper.openInvite}
								type='button'
							>
								<img alt='timeIcon' src={imagesAdd} />
								Invite new member
							</Button>
						</>
					)}
				</div>
			}
		>
			<TableTeams getPersonas={refetch} personas={personas} />
		</TeamUI.Wrapper>
	)
}
